import { render, staticRenderFns } from "./TwitchChat.vue?vue&type=template&id=68e73a34&scoped=true&"
import script from "./TwitchChat.vue?vue&type=script&lang=js&"
export * from "./TwitchChat.vue?vue&type=script&lang=js&"
import style0 from "./TwitchChat.vue?vue&type=style&index=0&id=68e73a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e73a34",
  null
  
)

export default component.exports